/* Woodlit product gallery tweaks (assets/wl-gallery.js, loaded by snippets/wl-gallery.liquid).
   Works on top of the theme's own gallery (product-images.js fader, product-thumbs.js, zoom.js +
   PhotoSwipe 4 through load-photoswipe.js). It never replaces them; it only:
   1. marks <html> while the photo viewer is open (chat launcher hidden by CSS),
   2. gives arrow / thumbnail / keyboard jumps in the viewer a 260 ms slide (CSS class wl-pswp-nav), and keeps
      the viewer's arrow keys from also moving the inline photo underneath,
   3. desktop: ArrowLeft / ArrowRight change the photo when focus is not in a form control,
   4. phones: the inline photo follows the finger and commits through the theme's own selectMedia(),
      and the photos either side of the current one are loaded ahead of the first swipe. */
(function () {
  'use strict';
  if (window.wlGallery) return;
  window.wlGallery = true;
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  /* 1 + 2: viewer */
  var pswp = document.querySelector('.pswp');
  if (pswp) {
    var html = document.documentElement;
    var sync = function () { html.classList.toggle('wl-pswp-open', pswp.classList.contains('pswp--open')); };
    new MutationObserver(sync).observe(pswp, { attributes: true, attributeFilter: ['class'] });
    sync();
    var navTimer = 0;
    var nav = function () {
      if (REDUCED.matches) return;
      pswp.classList.add('wl-pswp-nav');
      clearTimeout(navTimer);
      navTimer = setTimeout(function () { pswp.classList.remove('wl-pswp-nav'); }, 320);
    };
    var stopNav = function () { clearTimeout(navTimer); pswp.classList.remove('wl-pswp-nav'); };
    var ARROWS = '.pswp__button--arrow--left, .pswp__button--arrow--right';
    pswp.addEventListener('click', function (e) {
      if (e.target.closest(ARROWS + ', .pswp__thumbs > *')) nav();
    }, true);
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && pswp.classList.contains('pswp--open')) nav();
    }, true);
    // The inline gallery (product-images.js) steps on keyup of an arrow key when focus is inside it, as it is after a
    // click opened the viewer, so the photo underneath moved with every key and could land on the 3D slide, which a
    // click cannot open. PhotoSwipe steps on keydown, so the viewer keeps its keys.
    document.addEventListener('keyup', function (e) {
      if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && pswp.classList.contains('pswp--open')) e.stopPropagation();
    }, true);
    // PhotoSwipe moves the photo on pointerup (its tap), before click, so the arrows switch the slide on
    // pointerdown and again on pointerup (a long press would otherwise outlast the 320 ms window).
    pswp.addEventListener('pointerdown', function (e) {
      if (e.target.closest(ARROWS)) nav();
      else if (!e.target.closest('.pswp__thumbs, .pswp__button')) stopNav();
    }, true);
    pswp.addEventListener('pointerup', function (e) { if (e.target.closest(ARROWS)) nav(); }, true);
    pswp.addEventListener('touchstart', function (e) { if (!e.target.closest('.pswp__thumbs, .pswp__button')) stopNav(); }, { capture: true, passive: true });
  }

  /* 3: desktop keyboard */
  document.addEventListener('keydown', function (e) {
    if (MOBILE.matches || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (pswp && pswp.classList.contains('pswp--open')) return;          // PhotoSwipe handles its own keys
    var t = e.target;
    if (t && t.closest && t.closest('input, select, textarea, [contenteditable], [role="radiogroup"], [role="slider"], [role="tablist"], [data-product-media-list], .drawer, dialog, [aria-modal="true"]')) return;
    var pi = document.querySelector('product-images[data-fader-desktop]');
    if (!pi || typeof pi.showNextImage !== 'function') return;
    if (pi.querySelectorAll('[data-image-id]').length < 2) return;     // single photo: the theme has no next/previous
    var r = pi.getBoundingClientRect();
    if (r.bottom < 80 || r.top > window.innerHeight - 80) return;      // gallery not on screen
    e.preventDefault();
    if (e.key === 'ArrowRight') pi.showNextImage(); else pi.showPreviousImage();
  });

  /* 4: phones, inline photo follows the finger */
  function initSwipe(pi) {
    if (pi.wlSwipe) return;
    pi.wlSwipe = true;
    var list = pi.querySelector('[data-product-media-list]');
    if (!list) return;
    var st = null;
    var all = function () { return Array.prototype.slice.call(pi.querySelectorAll('[data-image-id]')); };
    var near = function (cur, dir) { var s = all(); var i = s.indexOf(cur); return s[(i + dir + s.length) % s.length]; };
    var clear = function (el) { if (!el) return; el.style.transform = ''; el.style.transition = ''; el.classList.remove('wl-peek'); };
    var eager = function (el) { var img = el && el.querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; };
    var abort = function () { if (!st) return; clear(st.cur); clear(st.nb); pi.classList.remove('wl-swiping'); st = null; };
    // The photos either side of the current one start downloading once the page has loaded and after every
    // photo change, so the first swipe already has its photo (it used to start only at touchstart).
    var warm = function () { var c = pi.querySelector('[data-image-id].media--active'); if (c && all().length > 1) { eager(near(c, 1)); eager(near(c, -1)); } };
    var idle = function () { if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 2000 }); else setTimeout(warm, 200); };
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
    pi.addEventListener('theme:media:select', function () { setTimeout(warm, 60); });

    pi.addEventListener('touchstart', function (e) {
      if (!MOBILE.matches || !pi.hasAttribute('data-fader-mobile') || pi.wlBusy) return;
      if (e.touches.length !== 1) { abort(); return; }
      var cur = pi.querySelector('[data-image-id].media--active');
      if (!cur || cur.getAttribute('data-type') !== 'image' || all().length < 2) return; // 3D / video keep today's behaviour
      var t = e.touches[0];
      st = { x: t.clientX, y: t.clientY, cur: cur, nb: null, dir: 0, dx: 0, lock: '', w: list.clientWidth, v: [[t.clientX, e.timeStamp]] };
      eager(near(cur, 1)); eager(near(cur, -1));
    }, { capture: true, passive: true });

    pi.addEventListener('touchmove', function (e) {
      if (!st || st.done) return;
      if (e.touches.length !== 1) { abort(); return; }
      var t = e.touches[0];
      var dx = t.clientX - st.x, dy = t.clientY - st.y;
      if (!st.lock) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        st.lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (st.lock === 'y') { st = null; return; }                    // page scroll, theme untouched
        pi.classList.add('wl-swiping');
      }
      e.stopPropagation();                                              // product-images.js does not see this swipe
      var dir = dx < 0 ? 1 : -1;
      var nb = near(st.cur, dir);
      if (st.nb && st.nb !== nb) clear(st.nb);
      st.nb = nb; st.dir = dir; st.dx = dx;
      st.v.push([t.clientX, e.timeStamp]); if (st.v.length > 5) st.v.shift();
      nb.classList.add('wl-peek');
      st.cur.style.transform = 'translate3d(' + dx + 'px,0,0)';
      nb.style.transform = 'translate3d(' + (dx + dir * st.w) + 'px,0,0)';
    }, { capture: true, passive: true });

    var end = function (e) {
      if (!st || st.lock !== 'x' || st.done) { st = null; return; }
      e.stopPropagation();
      pi.isDown = false;                                                // product-images.js state, set on touchstart
      requestAnimationFrame(function () { pi.classList.remove('is-dragging'); });
      var s = st; s.done = true;
      var a = s.v[0], b = s.v[s.v.length - 1];
      var vel = b[1] > a[1] ? (b[0] - a[0]) / (b[1] - a[1]) : 0;       // px per ms, negative = towards next
      var commit = e.type === 'touchend' && s.nb && (Math.abs(s.dx) > s.w * 0.2 || (Math.abs(vel) > 0.3 && (vel < 0) === (s.dx < 0)));
      var to = commit ? -s.dir * s.w : 0;
      var dur = REDUCED.matches ? 0 : commit ? Math.round(Math.max(180, Math.min(280, (s.w - Math.abs(s.dx)) / Math.max(Math.abs(vel), 1.4)))) : 200;
      pi.classList.remove('wl-swiping');
      var tr = 'transform ' + dur + 'ms ' + EASE;
      s.cur.style.transition = tr; s.nb && (s.nb.style.transition = tr);
      s.cur.style.transform = 'translate3d(' + to + 'px,0,0)';
      s.nb && (s.nb.style.transform = 'translate3d(' + (to + s.dir * s.w) + 'px,0,0)');
      pi.wlBusy = true;
      setTimeout(function () {
        pi.wlBusy = false;
        if (commit) {
          pi.classList.add('wl-swap');
          var id = s.nb.getAttribute('data-media-id');                    // the theme's own path: thumbs, height, aria, 3D autoload
          if (typeof pi.selectMedia === 'function') pi.selectMedia(id);
          else pi.dispatchEvent(new CustomEvent('theme:media:select', { detail: { id: id } }));
          clear(s.nb);
          requestAnimationFrame(function () { requestAnimationFrame(function () { clear(s.cur); pi.classList.remove('wl-swap'); }); });
        } else { clear(s.cur); clear(s.nb); }
        pi.classList.remove('wl-swiping');
        if (st === s) st = null;
      }, dur + 20);
    };
    pi.addEventListener('touchend', end, { capture: true });
    pi.addEventListener('touchcancel', end, { capture: true });
  }
  var boot = function () { Array.prototype.forEach.call(document.querySelectorAll('product-images'), initSwipe); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
